import { renderToStaticMarkup } from "react-dom/server";
import { icons, Wrench } from "lucide-react";

const ALIASES = { broom: "BrushCleaning" };
const pascal = (k) => ALIASES[k] || (k || "").split("-").map((w) => w.charAt(0).toUpperCase() + w.slice(1)).join("");

export const iconComponent = (key) => icons[pascal(key)] || Wrench;

export function ServiceIcon({ icon, className = "h-6 w-6", ...rest }) {
  const C = iconComponent(icon);
  return <C className={className} strokeWidth={2.2} {...rest} />;
}

export function markerHtml(icon) {
  const svg = renderToStaticMarkup(<ServiceIcon icon={icon} className="" width={22} height={22} color="#fff" />);
  return `<div style="width:44px;height:44px;border-radius:9999px;background:#F97316;border:3px solid #fff;box-shadow:0 4px 12px rgba(30,41,59,.35);display:flex;align-items:center;justify-content:center">${svg}</div>`;
}
